import React from 'react'

import Localization from '~/client/src/shared/localization/LocalizationManager'
import type { ResourceSchema } from '~/client/src/shared/resources/domain/resourceSchema'

import PropertyActionDialog from './PropertyActionDialog'

interface IProps {
  isOpen: boolean
  onClose: () => void
  propertyId: string
  projectId: string
  onDeleted: () => void
  resourceSchema: ResourceSchema
}

export default function DeletePropertyDialog({
  isOpen,
  onClose,
  propertyId,
  projectId,
  onDeleted,
  resourceSchema,
}: IProps) {
  const t = Localization.translator

  return (
    <PropertyActionDialog
      isOpen={isOpen}
      onClose={onClose}
      propertyId={propertyId}
      projectId={projectId}
      onComplete={onDeleted}
      resourceSchema={resourceSchema}
      action="delete"
      title={t.deleteProperty}
      confirmationWord="Delete"
      getConfirmationText={t.deletePropertyConfirmation}
      errorFallback={t.failedToDelete}
      useRedConfirmationButton
    />
  )
}
